import { MarkupTheme } from '@/components/Markup/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Markup = GenericSlot({ as: 'div', theme: MarkupTheme });
